import request from '@/utils/request'

// 添加地址
export const address = data => {
  return request({
    url: '/api/address/add',
    method: 'post',
    data
  })
}
// 获取地址
export const getAddress = data => {
  return request({
    url: '/api/address/get',
    method: 'get',
    params: data
  })
}
export const syncDress = data => {
  return request({
    url: '/api/address/sync',
    method: 'get',
    params: data
  })
}

// 删除地址
export const delAddress = data => {
  return request({
    url: '/api/address/del',
    method: 'get',
    params: data
  })
}
// 默认地址
export const setAddress = data => {
  return request({
    url: '/api/address/set',
    method: 'get',
    params: data
  })
}
// 编辑地址
export const editAddress = data => {
  return request({
    url: '/api/address/update',
    method: 'post',
    data
  })
}
// 店铺地址
export const shopdress = data => {
  return request({
    url: '/api/address/shopdress',
    method: 'get',
    params: data
  })
}
// 编辑店铺地址
export const editShopedit = data => {
  return request({
    url: '/api/address/shopedit',
    method: 'post',
    data
  })
}
// 多店铺
export const shop = data => {
  return request({
    url: '/api/address/shop',
    method: 'get',
    params: data
  })
}

// 多店铺
export const setDefaultShop = data => {
  return request({
    url: '/api/address/shop/default',
    method: 'post',
    data: data
  })
}
